import gql from 'graphql-tag'


export const SEE_CATEGORY = gql`
    query seeCategory($id:String!){
        seeCategory(id:$id){
            id
            categoryName
            categoryCount
        }
    }
`